import Seo from "@/components/Seo";
import { Eyebrow, Section, StatusChip } from "@/components/Type";

const CAPABILITIES = [
  "PERSONALISATION",
  "NUTRITION",
  "TRACKING",
  "BEHAVIOUR",
  "PERFORMANCE",
  "PROGRAMMES",
  "RECOMMENDATIONS",
  "INSIGHTS",
  "WEARABLE INTEGRATIONS",
  "ADAPTIVE HEALTH PLANNING",
];

export default function TechnologyPage() {
  return (
    <>
      <Seo
        title="Technology | W8ED"
        description="The future W8ED platform: technology that connects the system — data, insight, intervention, feedback, adaptation."
        path="/technology"
      />
      <section className="px-6 pb-20 pt-32 sm:pt-40">
        <div className="mx-auto max-w-6xl">
          <div className="flex flex-wrap items-center gap-4">
            <Eyebrow>Technology</Eyebrow>
            <StatusChip status="FUTURE W8ED PLATFORM" />
          </div>
          <h1 className="mt-8 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#f5f2ea] sm:text-6xl">
            TECHNOLOGY THAT CONNECTS THE SYSTEM.
          </h1>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#8e8a80]">
            Technology is the layer that will connect the eight pillars into one feedback loop —
            infrastructure for the W8ED system, not a product pretending to exist. There is no app
            today. No login. No dashboard. When it ships, it will earn its place.
          </p>
        </div>
      </section>

      <Section>
        <div className="grid items-start gap-16 lg:grid-cols-2">
          <div>
            <p className="font-mono text-[9px] tracking-[0.3em] text-[#57534a]">THE LOOP</p>
            <div className="mt-6 max-w-md">
              {["DATA", "INSIGHT", "INTERVENTION", "FEEDBACK", "ADAPTATION"].map((s, i) => (
                <div key={s}>
                  <p className="border border-[#1f1e1a] px-6 py-4 font-mono text-[11px] tracking-[0.3em] text-[#b8b3a6]">
                    {s}
                  </p>
                  {i < 4 && (
                    <p className="py-1 text-center font-mono text-[#C9A227]" aria-hidden="true">↓</p>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono text-[9px] tracking-[0.3em] text-[#57534a]">FUTURE CAPABILITIES</p>
            <ul className="mt-6 grid gap-px border border-[#1f1e1a] bg-[#1f1e1a] sm:grid-cols-2">
              {CAPABILITIES.map((c) => (
                <li key={c} className="bg-[#0a0a09] p-5">
                  <p className="font-mono text-[10px] tracking-[0.2em] text-[#b8b3a6]">{c}</p>
                  <p className="mt-2 font-mono text-[8px] tracking-[0.25em] text-[#57534a]">
                    IN DEVELOPMENT
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Section>
      <div className="py-16" />
    </>
  );
}
